export function hasLocationProperty(selectedProperties, hiddenProperties) {
    return selectedProperties.some(prop => {
        const lower = prop.toLowerCase();
        if (hiddenProperties.indexOf(lower) !== -1) return false;
        return lower.startsWith("location.") || lower.startsWith("location_");
    });
}
